import { render, staticRenderFns } from "./BSsetFacNumModel.vue?vue&type=template&id=0f5de356"
import script from "./BSsetFacNumModel.vue?vue&type=script&lang=js"
export * from "./BSsetFacNumModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports